import { surveyTimelineIcon } from "assets/icons";
import { duration } from "moment-timezone";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  formatMultiSelectArray,
  getValueOrFallback,
  isValidValue,
} from "utils/commonHelper";
import { getTimeDifference } from "utils/dateHelper";

const SurveyInfo = ({
  heading = "Survey Structure",
  surveyDetail,
  showHeader = false,
  showFooter = false,
  showInnerFooter = false,
  selectedSurveyDetail,
  totalQuestionCount,
}) => {
  const { t } = useTranslation();

  const surveyDetailTitle = {
    gender: t("STRUCTURE_PREVIEW.Gender"),
    // age: "Age",
    educationLevel: t("STRUCTURE_PREVIEW.Education Level"),
    livingSituation: t("STRUCTURE_PREVIEW.Living Situation"),
    region: t("STRUCTURE_PREVIEW.Region"),
    employementInfo: t("STRUCTURE_PREVIEW.Employment"),
    martialStatus: t("STRUCTURE_PREVIEW.Marital Status"),
    annualIncome: t("STRUCTURE_PREVIEW.Annual Income"),
  };

  function hasValues(obj) {
    return Object.keys(surveyDetailTitle).some((key) => {
      const value = surveyDetail[key];
      if (Array.isArray(value)) {
        return value.length > 0; // Check if array has elements
      }
      return value !== ""; // Check if the value is not an empty string
    });
  }

  // early return if this conditon match

  if (
    !showHeader &&
    !hasValues(surveyDetail) &&
    !isValidValue(selectedSurveyDetail?.duration) &&
    !isValidValue(selectedSurveyDetail?.expiryDate)
  ) {
    return null;
  }

  return (
    <div className="form_summery">
      <h4 style={{ textAlign: "center" }}>
        {t("STRUCTURE_PREVIEW.surveyDetail")}
      </h4>
      {showHeader && (
        <div>
          <p>{t("STRUCTURE_PREVIEW.totalQuestion")}</p>
          <p>{getValueOrFallback(totalQuestionCount)}</p>
        </div>
      )}
      {hasValues(surveyDetail) && (
        <>
          <h4>{heading}</h4>
          <h6>{t("STRUCTURE_PREVIEW.demographic")}</h6>
          <ul>
            {Object.keys(surveyDetail).map((key, index) => {
              if (surveyDetail?.[key]?.length && surveyDetailTitle[key]) {
                return (
                  <li key={`${key}-${index}`}>
                    <b>{surveyDetailTitle[key]}</b>
                    <p>
                      {surveyDetail[key]?.map((item, index) => (
                        <span key={`user-${key}-${index}`}>
                          {item?.label || ""}
                        </span>
                      ))}
                      {/* <span>{formatMultiSelectArray(surveyDetail[key])}</span> */}
                    </p>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </>
      )}
      {showFooter && (
        <div>
          {showInnerFooter && (
            <div>
              <div>
                <p>{t("STRUCTURE_PREVIEW.pricePerParticipant")}</p>
                <p>
                  {`${getValueOrFallback(
                    selectedSurveyDetail?.rewardPerPerson
                  )} ${t("COMMON.SAR")}`}
                </p>
              </div>
              <div>
                <p>{t("STRUCTURE_PREVIEW.totalParticipant")}</p>
                <p>{selectedSurveyDetail?.userCount || 0}</p>
              </div>
              <div>
                <p>{t("STRUCTURE_PREVIEW.totalCost")}</p>
                <p>
                  {`${
                    (selectedSurveyDetail?.rewardPerPerson || 0) *
                    (selectedSurveyDetail?.userCount || 0)
                  } ${t("COMMON.SAR")}`}
                </p>
              </div>
            </div>
          )}
          {isValidValue(selectedSurveyDetail?.duration) && (
            <div>
              <p>{t("STRUCTURE_PREVIEW.surveyDuration")}</p>
              <p>{`${getValueOrFallback(
                selectedSurveyDetail?.duration
              )} min`}</p>
            </div>
          )}
          {isValidValue(selectedSurveyDetail?.expiryDate) && (
            <div className="survey_timeline">
              <img src={surveyTimelineIcon} alt="" />
              <span>{t("STRUCTURE_PREVIEW.surveyComplete")}</span>{" "}
              <b>{`~${
                getTimeDifference(
                  null,
                  selectedSurveyDetail?.expiryDate,
                  "days"
                ) || "---"
              }`}</b>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SurveyInfo;
